<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>{{nomefor}}</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Requisições de Clientes</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO NOME DO DEPENDENTE -->
                  <v-flex xs12 sm12>
                    <v-select
                      :items="clientes"
                      filled
                      v-model="cliente.id"
                      item-text="nome"
                      item-value="id"
                      label="Clientes"
                      @input="onClienteSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="profissional"
                      filled
                      v-model="requisicao.fk_profissional"
                      item-text="nome"
                      item-value="id"
                      label="Motoristas"
                      @input="onProfissionalSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="veiculo"
                      filled
                      v-model="requisicao.fk_veiculo"
                      item-text="descricao"
                      item-value="id"
                      label="Veículos"
                      @input="onVeiculoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="requisicao.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="requisicao.data_lancto"
                      label="Data"
                      type="tel"
                      v-mask="'##/##/####'"
                      required
                      @input="onDataInicio()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <v-select
                      :items="plano"
                      filled
                      v-model="requisicao.fk_plano"
                      item-text="descricao"
                      item-value="id"
                      label="Descrição"
                      @input="onPlanoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="odometroanterior"
                      v-bind="currency_config"
                      label="Odômetro Anterior"
                      readonly
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="requisicao.odometro"
                      v-bind="currency_config"
                      label="Odômetro"
                      @input="onOdometroSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="kmrodado"
                      v-bind="currency_config"
                      label="Km rodado"
                      readonly
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="litros"
                      label="Litros"
                      v-bind="currency_litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2 v-if="preco_litro !== '0.0000'">
                    <v-currency-field
                      v-model="preco_litro"
                      v-bind="currency_litro"
                      label="Preço litro"
                      @input="onValorSelect()"
                      readonly
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2 v-if="preco_litro === '0.0000'">
                    <v-currency-field
                      v-model="preco_litro"
                      v-bind="currency_litro"
                      label="Preço litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="valor_total"
                      label="Valor total"
                      v-bind="currency_2"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="visivel === 'S'">
                    <v-switch
                      label="Completando tanque ?"
                      v-model="requisicao.tanque_cheio"
                      false-value="N"
                      true-value="S"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <p id="paragrafo">
                      <span style="color: #FFFFFF;">{{valor_teste}}</span>
                    </p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
        </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/requisicoescliente')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onLanctoSaveClick()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError, validateDate } from '@/utils'
import planoService from '@/services/plano'
import requisicaoService from '@/services/requisicao'
// import fornecedorService from '@/services/fornecedor'
// import profissionalService from '@/services/profissional'
// import veiculosService from '@/services/veiculos'
// import empresafornecedorService from '@/services/empresa_fornecedor'
import store from '@/store'
// import VueQrcode from 'vue-qrcode'
// import { QrcodeStream } from 'vue-qrcode-reader'
// import { QrcodeStream } from 'vue-qrcode-reader'
// import QrcodeStream from 'qrcode-stream'
// import { QrcodeStream } from '../../../src'

export default {
  name: 'requisicoescliente',
  data () {
    return {
      idposto: 0,
      idprefeitura: 0,
      fk_depto: 0,
      litros: 0,
      preco_litro: 0,
      valor_total: 0,
      kmrodado: 0,
      odometroanterior: 0,
      visivel: 'N',
      barraprofissional: '',
      tipo: '',
      valor_teste: 0,
      baixado: '',
      seguro: 0,
      despesas: 0,
      receitas: 0,
      liquido: 0,
      total: 100,
      idviagem: 0,
      admin: false,
      requisicoes: [],
      transportadora: [],
      clientes: [],
      cliente: {},
      headers: [
        { text: 'Descrição', value: 'descricao', sortable: false },
        { text: 'Valor', value: 'valor_total', sortable: false }],
      item: {
        lanctto: ''
      },
      itemrequisicao: {
        descr: ''
      },
      // tipolanctos: ['Abastecimento', 'Despesa', 'Serviço', 'Receita'],
      tipolanctos: ['Abastecimento'],
      dependenteValid: true,
      dependentes: [],
      plano: [],
      profissional: [],
      veiculo: [],
      idveiculo: 0,
      nomefor: '',
      idprofissional: 0,
      idfornecedor: 0,
      idcliente: 0,
      dependente: {},
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 0,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      currency_litro: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 4,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      currency_2: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      viagem: {},
      requisicao: {},
      itemList: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      menuDateNascimento: false,
      resultado: {},
      itemSenha: [
        'N',
        'S'
      ]
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.requisicao = {}
      this.requisicao.id = '0'
      this.profissional = []
      this.veiculo = []
      this.clientes = []
      this.idfornecedor = 0
      this.admin = false
      var data = new Date()
      var dia1 = data.getDate()
      var dia = dia1 < 10 ? '0' + dia1 : '' + dia1
      var mes1 = data.getMonth() + 1
      var mes = mes1 < 10 ? '0' + mes1 : '' + mes1
      var ano = data.getFullYear()
      var dtini = dia + '/' + mes + '/' + ano
      this.requisicao.data_lancto = dtini
      this.tipo = store.tipo
      this.requisicao.tanque_cheio = 'N'
      this.modo = 'I'
      this.baixado = 'N'
      this.idposto = store.idposto
      this.idprefeitura = store.idprefeitura
      this.profissional = store.motoristas
      this.veiculo = store.veiculos
      this.transportadora = store.clientes
      this.clientes = store.clientes
      this.cliente.id = store.idposto
      this.idcliente = store.idposto
      this.tipolanctos = []
      this.tipolanctos.push(this.requisicao.tipo)
      this.itemrequisicao.descr = 'Abastecimento'
      this.plano = store.plano
      this.idposto = store.idposto
      this.idprefeitura = store.idprefeitura
      if (id !== undefined) {
        this.modo = 'A'
        const resultl = await requisicaoService.getById(id)
        if (resultl.data[0] !== undefined) {
          this.requisicao = resultl.data[0]
          this.itemrequisicao.descr = resultl.data[0].tipo
          this.idfornecedor = this.requisicao.fk_fornecedor
          this.idprofissional = this.requisicao.fk_profissional
          this.idveiculo = this.requisicao.fk_veiculo
          this.baixado = this.requisicao.baixado
          this.idcliente = this.requisicao.empresa_id
          this.itemrequisicao.descr = this.requisicao.tipo
          this.cliente.id = this.requisicao.empresa_id
          this.cliente.id = this.requisicao.fk_fornecedor
          this.odometroanterior = this.requisicao.odometro_anterior
          this.kmrodado = this.requisicao.kmrodado
          this.tipolanctos = []
          this.tipolanctos.push(this.requisicao.tipo)
          this.litros = this.requisicao.litros
          this.preco_litro = this.requisicao.preco_litro
          this.valor_total = this.requisicao.valor_total
          // this.onLanctoSelect()
          // var result4 = await requisicaoService.getByEmpresas(this.requisicao.empresa_id)
          // if (result4.data === undefined) {
          // showError('Não localizei empresas!!!')
          // return
          // }
          // this.clientes = result4.data
        }
      }
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    onLanctoNewClick () {
      this.requisicao.odometro = 0
      this.requisicao.litros = 0
      this.requisicao.valor_total = 0
      this.requisicao.preco_litro = 0
      this.plano = []
    },
    async onPlanoSelect () {
      var passo
      for (passo = 0; passo <= this.plano.length - 1; passo++) {
        if (this.plano[passo].id === this.requisicao.fk_plano) {
          // this.requisicao.preco_litro = this.plano[passo].valor
          this.preco_litro = this.plano[passo].valor
        }
      }
    },
    onOdometroSelect () {
      if (this.odometroanterior !== 0 && this.requisicao.odometro !== 0) {
        var tt = this.requisicao.odometro - this.odometroanterior
        this.kmrodado = tt
      } else {
        this.kmrodado = 0
      }
    },
    async onClienteSelect () {
      this.requisicao.odometro = 0
      this.requisicao.litros = 0
      this.requisicao.valor_total = 0
      this.requisicao.preco_litro = 0
      this.requisicao.tanque_cheio = 'N'
      this.plano = []
      this.idcliente = this.cliente.id
      this.idfornecedor = store.fk_fornecedor
      // var result3 = await requisicaoService.getByTodos(this.idcliente)
      var result3 = await requisicaoService.getByTodos(this.idcliente, store.fk_fornecedor)
      if (result3.data === undefined) {
        // this.veiculo = result1.data
        showError('Não localizei clientes, profissionais e veículos!!!')
        return
      }
      this.profissional = result3.data.motoristas
      this.veiculo = result3.data.veiculos
      this.transportadora = result3.data.clientes
      this.tipolanctos = []
      this.tipolanctos.push(this.requisicao.tipo)
      this.itemrequisicao.descr = 'Abastecimento'
      this.onLanctoSelect()
    },
    async onFornecedorSelect () {
      this.idfornecedor = this.requisicao.fk_fornecedor
    },
    async onProfissionalSelect () {
      this.idprofissional = this.requisicao.fk_profissional
    },
    async onVeiculoSelect () {
      var passo
      for (passo = 0; passo <= this.veiculo.length - 1; passo++) {
        if (this.veiculo[passo].id === this.requisicao.fk_veiculo) {
          this.odometroanterior = this.veiculo[passo].odometro
          this.fk_depto = this.veiculo[passo].fk_depto
          break
        }
      }
      this.idveiculo = this.requisicao.fk_veiculo
      // this.odometroanterior
    },
    onValorSelect1 () {
      if (this.requisicao.litros !== undefined && this.requisicao.preco_litro !== undefined && this.requisicao.litros > 0 && this.requisicao.preco_litro > 0) {
        var tt = this.requisicao.preco_litro * this.requisicao.litros
        const total = tt.toFixed(2)
        this.requisicao.valor_total = total
        this.valor_teste = total
      }
    },
    onValorSelect () {
      if (this.litros !== undefined && this.preco_litro !== undefined && this.litros > 0 && this.preco_litro > 0) {
        var tt = this.preco_litro * this.litros
        const total = tt.toFixed(2)
        this.valor_total = total
        this.valor_teste = total
      }
    },
    async onLanctoSelect () {
      this.plano = []
      try {
        const result = await planoService.getByLista(this.idcliente)
        if (result.data !== undefined) {
          this.plano = result.data
        }
      } catch (error) {
        showError(error)
      } finally {
      }
    },
    async onLanctoSaveClick () {
      try {
        this.requisicao.litros = this.litros
        this.requisicao.preco_litro = this.preco_litro
        this.requisicao.valor_total = this.valor_total
        if (this.baixado !== 'N') {
          showError('Requisição não pode ser alterada!!!')
          return
        }
        if (this.idposto === 0) {
          showError('Não localizei fornecedor!!!')
          return
        }
        if (this.idprofissional === 0) {
          showError('Não localizei profissional!!!')
          return
        }
        if (this.idveiculo === 0) {
          showError('Não localizei veículo!!!')
          return
        }
        if (this.requisicao.odometro === 'None' || this.requisicao.odometro === 0) {
          showError('Odômetro inválido!!!')
          return
        }
        if (this.requisicao.litros === 'None' || this.requisicao.litros === 0) {
          showError('Litros inválidos!!!')
          return
        }
        if (this.requisicao.preco_litro === 'None' || this.requisicao.preco_litro === 0) {
          showError('Preço por litro inválido!!!')
          return
        }
        if (this.requisicao.valor_total === 'None' || this.requisicao.valor_total === 0) {
          showError('Total inválido!!!')
          return
        }
        this.requisicao['fk_veiculo'] = this.idveiculo
        this.requisicao['fk_profissional'] = this.idprofissional
        this.requisicao['fk_fornecedor'] = this.idposto
        this.requisicao['fk_empresa'] = this.idprefeitura
        this.requisicao['baixado'] = 'S'
        this.requisicao['fk_depto'] = this.fk_depto
        this.requisicao['idposto'] = this.idposto
        this.requisicao['idprefeitura'] = this.idprefeitura
        const ret = await requisicaoService.savePostBaixa(this.requisicao)
        if (ret !== undefined) {
          this.requisicao.odometro = 0
          this.requisicao.litros = 0
          this.requisicao.valor_total = 0
          this.requisicao.preco_litro = 0
          this.requisicao.fk_profissional = 0
          this.requisicao.fk_veiculo = 0
          this.requisicao.id = 0
          this.requisicao.fk_plano = 0
          this.odometroanterior = 0
          this.kmrodado = 0
          this.veiculo = ret.data.data
          this.litros = 0
          this.valor_total = 0
          this.preco_litro = 0
          showFlash('Salvo com sucesso')
        }
      } catch (error) {
        showError(error)
      }
    },
    async onDataInicio () {
      try {
        if (this.requisicao.data_lancto.length === 10) {
          var ret = validateDate(this.requisicao.data_lancto)
          if (ret === false) {
            showError('Data inválida')
            this.requisicao.data_lancto = ''
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        // this.ultimoLancamentoLoadingIsVisible = false
      }
    },
    onSelectOrigem (item) {
      this.viagem.fk_origem = item.codigo
    },
    onSelectDestino (item) {
      this.viagem.fk_destino = item.codigo
    }
  }
}
</script>
<style scoped>
#create-post video, #create-post canvas {
  width: 512px;
  max-width: 100%;
  display: none;
  margin: auto;
}
#create-post #pick-image {
  display: none;
}
#create-post #capture-btn {
  margin: 10px auto;
}
.mdl-spinner {
  margin: auto;
}

.main-image {
  max-width: 100%;
  margin: auto;
  display: block;
}
.flex{
    height: 60px;
}
</style>
